import React from "react";
import {
    Dialog,
    DialogContent,
    IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const FullScreenMediaModal = ({
    open,
    onClose,
    media,
    isVideo
}) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogContent sx={{ background: "#000", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        color: "white",
                        backgroundColor: "rgba(255, 255, 255, 0.2)",
                        "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.3)" }
                    }}
                >
                    <CloseIcon sx={{ color: "white", fontSize: "1.8rem" }} />
                </IconButton>
                {media && (
                    isVideo ? (
                        <video width="90%" height="auto" controls autoPlay>
                            <source src={media} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    ) : (
                        <img src={media} alt="Fullscreen" style={{ width: "90%", height: "auto", borderRadius: 4 }} />
                    )
                )}
            </DialogContent>
        </Dialog>
    );
};

export default FullScreenMediaModal;